import React from "react";
import Icon from "../Icon/Icon";
import WeaveInputWidget from "../WeaveInputWidget/WeaveInputWidget";
import SectionTitleWidget from "../SectionTitleWidget/SectionTitleWidget";

import s from "./SectionInputWidget.module.scss";

export default function SectionInputWidget({
	value,
	icon,
	title,
	placeholder,
	subTitle,
	type = "text",
	className = "",
	disabled = false,
	onChange = () => {},
}) {
	return (
		<div className={s.root}>
			{title && (
				<SectionTitleWidget icon={<Icon icon={icon} />} title={title} />
			)}

			<WeaveInputWidget
				value={value || ""}
				type={type}
				disabled={disabled}
				className={className}
				placeholder={placeholder}
				label={subTitle}
				onChange={(val) => onChange(val)}
			/>
		</div>
	);
}
